// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__LPxUu","dragIcon":"Choice_dragIcon__3rpJm","left":"Choice_left__xmS3E","input":"Choice_input__3a-yd"};